<div class="emergency-modal">
    <header class="emergency-modal__header">
        <h2 role="heading" translate>contact.need</h2>
        <button type="button" class="emergency-modal__close" aria-label="Close" (click)="dialogRef?.close()">
            <svg-icon icon="close"></svg-icon>
        </button>
    </header>

    <p class="emergency-modal__description" [innerHTML]="contactDescription"></p>

    <div class="emergency-modal__channels" *ngIf="!isHotline">
        <button
            *ngIf="contactGroupTelephone"
            type="button"
            class="emergency-channel"
            (click)="callOrMsgEmergencyConatct('call', contactGroupTelephone)">
            <span class="emergency-channel__action">
                <img src="../../../assets/img/icons-svg/emergency-calling.svg" alt="" />
                <span class="emergency-channel__label" translate>contact.popupCallbtn</span>
            </span>
            <span class="emergency-channel__number">
                <span>{{ contactGroupTelephone }}</span>
                <button
                    type="button"
                    class="emergency-channel__copy"
                    aria-label="Copy number"
                    (click)="$event.stopPropagation(); numberCopied(contactGroupTelephone)">
                    <img src="../../../assets/img/icons-svg/copy.svg" alt="" />
                </button>
            </span>
        </button>

        <button
            *ngIf="contactGroupTextMsgNumber"
            type="button"
            class="emergency-channel"
            (click)="isSmsSupported ? callOrMsgEmergencyConatct('msg', contactGroupTextMsgNumber) : numberCopied(contactGroupTextMsgNumber)">
            <span class="emergency-channel__action">
                <img src="../../../assets/img/icons-svg/emergency-message.svg" alt="" />
                <span class="emergency-channel__label" translate>contact.popupMessagebtn</span>
            </span>
            <span class="emergency-channel__number">
                <span>{{ contactGroupTextMsgNumber }}</span>
                <button
                    type="button"
                    class="emergency-channel__copy"
                    aria-label="Copy number"
                    (click)="$event.stopPropagation(); numberCopied(contactGroupTextMsgNumber)">
                    <img src="../../../assets/img/icons-svg/copy.svg" alt="" />
                </button>
            </span>
        </button>
    </div>

    <div class="emergency-modal__channels" *ngIf="isHotline">
        <span class="app-c-spinner spinner-class" *ngIf="!hotline" aria-label="Loading"></span>
        <ng-container *ngIf="hotline">
            <button
                type="button"
                class="emergency-channel"
                (click)="callOrMsgEmergencyConatct('call', hotline?.telephone); dialogRef?.close()">
                <span class="emergency-channel__action">
                    <img src="../../../assets/img/icons-svg/emergency-calling.svg" alt="" />
                    <span class="emergency-channel__label" translate>contact.popupCallbtn</span>
                </span>
                <span class="emergency-channel__number">
                    <span>{{ hotline?.telephone }}</span>
                    <button
                        type="button"
                        class="emergency-channel__copy"
                        aria-label="Copy number"
                        (click)="$event.stopPropagation(); numberCopied(hotline?.telephone)">
                        <img src="../../../assets/img/icons-svg/copy.svg" alt="" />
                    </button>
                </span>
            </button>
            <button
                *ngIf="isSmsSupported"
                type="button"
                class="emergency-channel"
                (click)="callOrMsgEmergencyConatct('msg', hotline?.telephone); dialogRef?.close()">
                <span class="emergency-channel__action">
                    <img src="../../../assets/img/icons-svg/emergency-message.svg" alt="" />
                    <span class="emergency-channel__label" translate>contact.popupMessagebtn</span>
                </span>
                <span class="emergency-channel__number">
                    <span>{{ hotline?.telephone }}</span>
                </span>
            </button>
        </ng-container>
    </div>
</div>
